import { connect } from 'react-redux'
import Table from './Table'

import onChangeTable from './Handlers/onChangeTable'

const mapStateToProps = (state) => ({
  subValuations: state.screens.SubValuations.subValuations,
  fetching: state.screens.SubValuations.fetching,
  pagination: state.screens.SubValuations.pagination,
})

const actionCreators = {
  onChangeTable,
}

export default connect(mapStateToProps, actionCreators)(Table)
